import {gql} from "@apollo/client";

const CORE_METRIC_TYPE_FIELDS = gql`
  fragment CoreMetricTypeFields on MetricType {
    id
    name
    description
    measureAgainst
    isDeleted
  }
`;

export const GET_METRIC_TYPES = gql`
  ${CORE_METRIC_TYPE_FIELDS}
  query GetMetricTypes {
    metricTypes {
      ...CoreMetricTypeFields
      inUseBy {
        model
        count
      }
    }
  }
`;

export const GET_METRIC_MEASURE_AGAINST_TYPES = gql`
  query GetMetricMeasureAgainstTypes {
    measureAgainstTypes: __type(name: "MeasureAgainst") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const CREATE_METRIC_TYPE = gql`
  ${CORE_METRIC_TYPE_FIELDS}
  mutation CreateMetricType(
    $name: String!
    $description: String
    $measureAgainst: MeasureAgainst!
  ) {
    createOneMetricType(
      data: {name: $name, description: $description, measureAgainst: $measureAgainst}
    ) {
      ...CoreMetricTypeFields
    }
  }
`;

export const UPDATE_METRIC_TYPE = gql`
  ${CORE_METRIC_TYPE_FIELDS}
  mutation UpdateMetricType(
    $id: Int!
    $name: String!
    $description: String
    $measureAgainst: MeasureAgainst!
  ) {
    updateOneMetricType(
      where: {id: $id}
      data: {
        name: {set: $name}
        description: {set: $description}
        measureAgainst: {set: $measureAgainst}
      }
    ) {
      ...CoreMetricTypeFields
    }
  }
`;

export const SOFT_DELETE_METRIC_TYPE = gql`
  ${CORE_METRIC_TYPE_FIELDS}
  mutation SoftDeleteMetricType($id: Int!) {
    deleteOneMetricType(where: {id: $id}) {
      ...CoreMetricTypeFields
    }
  }
`;
